import React, { useContext, VFC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '@material-ui/core/styles';

import SignupImage from '../../../images/header/nav/signup.png';
import LoginImage from '../../../images/header/nav/login.png';
import { AuthDialogContext } from '../../AuthDialog/AuthDialogContextProvider';
import Styled from '../Styled';
import ImgIconWithWord from '../molecules/ImgIconWithWord';
import SearchIconLink from '../molecules/SearchIconLink';

const { IconWrapper, IconLink } = Styled;

interface Props {
  handleOpenSearchDrawer: () => void;
}
const NotLoggedInContent: VFC<Props> = ({ handleOpenSearchDrawer }: Props) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const {
    handleOpen: handleOpenAuthDialogInContext,
    handleOpenSignupDialog: handleOpenSignupDialogInContext,
  } = useContext(AuthDialogContext);

  const handleOpenAuthDialog = () => {
    handleOpenAuthDialogInContext();
  };
  const handleOpenSignupDialog = () => {
    handleOpenSignupDialogInContext();
  };

  return (
    <>
      <SearchIconLink onClick={handleOpenSearchDrawer} />
      <IconWrapper theme={theme}>
        <IconLink>
          <ImgIconWithWord
            src={SignupImage}
            alt={t('common.signup')}
            word={t('common.signup')}
            onClick={handleOpenSignupDialog}
          />
        </IconLink>
      </IconWrapper>
      <IconWrapper theme={theme}>
        <IconLink>
          <ImgIconWithWord
            src={LoginImage}
            alt={t('common.login')}
            word={t('common.login')}
            onClick={handleOpenAuthDialog}
          />
        </IconLink>
      </IconWrapper>
    </>
  );
};

export default NotLoggedInContent;
